import * as React from "react";
import { InjectedFormProps, reduxForm, Field, ConfigProps } from "redux-form";
import { ISearchParams } from "~/store/reducers/search/search-reducer";
import { ISearchResultsProps } from "../search-results";
import * as searchActions from "~/store/reducers/search/search-actions";
import InputSelect from "../../input-select/input-select";

interface ISortingOption {
    label: string;
    value: string;
}
export interface ISortingFormProps {
    sortingOptions: ISortingOption[];
}

interface ISortingFormAllProps
    extends ISortingFormProps,
        Pick<ISearchParams, "sorting">,
        Pick<ISearchResultsProps, "loadMoreWebApiUrl"> {}

export interface ISortingFormData {
    sorting: string;
}

type SortingFormPropsUnion = ISortingFormAllProps & InjectedFormProps<ISortingFormData, ISortingFormAllProps>;

const SortingForm: React.FC<SortingFormPropsUnion> = props => {
    return (
        <form className="sorting-form">
            <Field
                name="sorting"
                component={InputSelect}
                fieldName="select"
                excludeDefaultOption
                readyForSorting
                options={props.sortingOptions}
            />
        </form>
    );
};

const formConfig: ConfigProps<ISortingFormData, ISortingFormAllProps> = {
    form: "sortingForm",
    onChange: (values, dispatch, props) => {
        if (props.anyTouched) {
            dispatch(
                searchActions.searchRequest({
                    apiUrl: props.loadMoreWebApiUrl,
                    page: 0,
                    sorting: values.sorting
                })
            );
        }
    },
    touchOnChange: true
};

export default reduxForm<ISortingFormData, ISortingFormAllProps>(formConfig)(SortingForm);
